/**
 * Tiny dev-only logger. In production builds (NODE_ENV === "production"),
 * these become no-ops so we don't leak internals to the browser console.
 */
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  debug: isDev ? console.debug.bind(console) : () => {},
  info: isDev ? console.info.bind(console) : () => {},
  warn: isDev ? console.warn.bind(console) : () => {},
  error: isDev ? console.error.bind(console) : () => {},
};

export default logger;
